module.exports = __webpack_public_path__ + "img/btn_winner.f5d51251.png";